module.exports = __webpack_public_path__ + "img/header.2f6e926c.png";